<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    aria-hidden="true"
    class="viq-lens-icon"
  >
    <!-- tracker: Radar/signal -->
    <template v-if="iconKey === 'tracker'">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.808-3.808-9.98 0-13.788m13.788 0c3.808 3.808 3.808 9.98 0 13.788M12 12h.008v.008H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
    </template>
    <!-- briefing: Clipboard -->
    <template v-else-if="iconKey === 'briefing'">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15a2.25 2.25 0 012.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
    </template>
    <!-- gap: Shield -->
    <template v-else-if="iconKey === 'gap'">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM9.879 3.226l-7.17 3.583A1.5 1.5 0 002 8.197v3.394c0 4.84 3.17 9.374 7.879 10.878a1.5 1.5 0 00.863.02C15.434 21.21 19 16.88 19 11.59V8.197a1.5 1.5 0 00-.709-1.388l-7.17-3.583a1.5 1.5 0 00-1.242 0z" />
    </template>
    <!-- market: Globe -->
    <template v-else-if="iconKey === 'market'">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5a17.92 17.92 0 01-8.716-2.247m0 0A8.966 8.966 0 013 12c0-1.04.177-2.04.502-2.968" />
    </template>
    <!-- explainer: Light bulb -->
    <template v-else-if="iconKey === 'explainer'">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
    </template>
    <!-- default: Sliders/adjustments -->
    <template v-else>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
    </template>
  </svg>
</template>

<script>
const EMOJI_MAP = {
  "\uD83D\uDCE1": "tracker",
  "\uD83D\uDCCB": "briefing",
  "\uD83D\uDD0D": "gap",
  "\uD83C\uDF10": "market",
  "\uD83D\uDCA1": "explainer",
};

const ID_MAP = {
  "vixio-regulatory-tracker": "tracker",
  "vixio-board-briefing-writer": "briefing",
  "vixio-compliance-gap-checker": "gap",
  "vixio-market-entry-advisor": "market",
  "vixio-regulation-explainer": "explainer",
};

export default {
  name: "ViqLensIcon",
  props: {
    value: {
      type: String,
      default: "",
    },
    size: {
      type: [String, Number],
      default: 16,
    },
  },
  computed: {
    iconKey() {
      const v = this.value || "";
      // Direct match (emoji field value like "tracker", "briefing")
      if (["tracker", "briefing", "gap", "market", "explainer"].includes(v)) {
        return v;
      }
      return ID_MAP[v] || EMOJI_MAP[v] || "default";
    },
  },
};
</script>
